import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";

export function useBillingUsage() {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: ["org", org],

    queryFn: () =>
      api
        .get<"/orgs/:orgId/monthly-tracked-users">(
          `/orgs/${org.id}/monthly-tracked-users`,
        )
        .then((res) =>
          res.data.map((d) => ({
            month: new Date(d.month),
            trackedUsers: d.trackedUsers,
          })),
        ),

    enabled: Boolean(org),
  });
}
